if (!customElements.get('ep-collection-nav')) {
  customElements.define(
    'ep-collection-nav',
    class EpCollectionNav extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.ep-collection-nav__toggle');
        this.body = this.querySelector('.ep-collection-nav__body');

        if (this.toggle) {
          this.toggle.addEventListener('click', this.onToggle.bind(this));
        }

        // Parent items expand/collapse their children in place (no navigation).
        this.onParentToggle = this.onParentToggle.bind(this);
        this.querySelectorAll('.ep-collection-nav__parent').forEach((btn) => {
          btn.addEventListener('click', this.onParentToggle);
        });

        this.onResize = this.onResize.bind(this);
        window.addEventListener('resize', this.onResize);
        this.onResize();
      }

      onParentToggle(event) {
        const btn = event.currentTarget;
        const item = btn.closest('.ep-collection-nav__item');
        if (!item) return;
        const open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      get isMobile() {
        return window.matchMedia('(max-width: 1199.98px)').matches;
      }

      onToggle() {
        if (!this.isMobile) return;
        const open = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      onResize() {
        // On desktop the body is always visible; reset mobile state.
        if (!this.isMobile) {
          this.classList.remove('is-expanded');
          if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
        }
      }
    }
  );
}
